/*
 * The fleet's stored workspace choice (the reference CMS design @ `c4387239`,
 * `modules-user-management/src/frontend/hooks/user-management`), taken as it
 * stands — the key included, because it is what a browser already holding one
 * of these consoles' choices has written.
 */
import { useLocalStorage } from '@uidotdev/usehooks'

const STORAGE_KEY = 'selectedWorkspaceId_v2'

export const useSelectedWorkspace = () => {
  return useLocalStorage<string | null>(STORAGE_KEY, null)
}
